import { gql, useQuery, QueryHookOptions } from '@apollo/client'
import { OrgInvitationStatus } from '~/app/Org/OrgSettings/types'

export interface Invitation {
  id: number
  email: string
  role: string
  status: OrgInvitationStatus
  createdAt: string
}

export interface OrgInvitationsResponse {
  orgInvitations: Invitation[]
}

const ORG_INVITATIONS_QUERY = gql`
  query OrgInvitationsQuery($orgId: Int!) {
    orgInvitations(orgId: $orgId) {
      id
      email
      role
      status
      createdAt
    }
  }
`

export const useOrgInvitationsQuery = (orgId: number, options?: QueryHookOptions) => {
  const { data, loading, error, refetch } = useQuery<OrgInvitationsResponse>(
    ORG_INVITATIONS_QUERY,
    {
      variables: { orgId },
      ...options
    }
  )

  const refetchOrgInvitations = async () => {
    const response = await refetch({
      orgId
    })
    return response.data?.orgInvitations ?? []
  }

  return {
    invitations: data?.orgInvitations ?? [],
    loading,
    error,
    refetchOrgInvitations
  }
}

export default useOrgInvitationsQuery
